import { useDispatch, useSelector } from 'react-redux';
import React, { useState } from 'react';
import { acceptTos } from './issues-slice';
import { Button, Checkbox, Divider, Modal } from 'semantic-ui-react';
import { acceptDocumentTos } from '../document/documents-slice';
import { useIntl, FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';

const prefix = 'eSignatureDisclosureModal';

export default function ESignDisclosureModal({ tosNotAccepted, issueType }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isChecked, setIsChecked] = useState(false);
  const [error, setError] = useState(false);
  const itemAssignmentCode = useSelector((state) => state.auth.user.itemAssignmentCode);

  const intl = useIntl();
  const translatedIssueType = intl.formatMessage({
    id: `issueType.${issueType}`,
    defaultMessage: `${issueType}`,
  });
  function handleContinue() {
    if (!isChecked) {
      setError(true);
    } else {
      setError(false);
      if (issueType === 'document') {
        dispatch(acceptDocumentTos({ itemAssignmentCode, navigate }));
      } else {
        dispatch(acceptTos({ itemAssignmentCode, navigate }));
      }
    }
  }

  return (
    <Modal open={tosNotAccepted} size="tiny" className="e-sign-disclosure-modal">
      <Modal.Content>
        <Divider hidden></Divider>
        <h2 className="ui header">
          <FormattedMessage id={`${prefix}.disclosure`} defaultMessage="E-Signature Disclosure" />
        </h2>
        <Checkbox
          checked={isChecked}
          onChange={() => setIsChecked(!isChecked)}
          label={
            <label>
              <span className="agree-to-use-e-sign">
                <FormattedMessage
                  id={`${prefix}.acceptToUse`}
                  defaultMessage={'I agree to use electronic records and signatures.'}
                />
              </span>{' '}
              <a
                href={window.config.eSignatureDisclosure}
                target="_blank"
                className="read-e-disclosure"
                rel="noreferrer"
              >
                <FormattedMessage id={`${prefix}.pleaseRead`} defaultMessage="Please read E-Signature Disclosures." />
              </a>
            </label>
          }
        />
        {error && (
          <div className="ui pointing basic label form-error-message">
            <FormattedMessage id={`${prefix}.selectCheckbox`} defaultMessage="Please select the checkbox" />
          </div>
        )}
        <Divider hidden></Divider>
        <Modal.Actions>
          <div className="ui row">
            {' '}
            <Button className="ui green button accept-button" onClick={handleContinue}>
              <FormattedMessage
                id={`${prefix}.review`}
                defaultMessage={`Accept & Review ${translatedIssueType}`}
                values={{ translatedIssueType }}
              />
            </Button>
          </div>
        </Modal.Actions>
        <Divider hidden></Divider>
      </Modal.Content>
    </Modal>
  );
}
